export const removeAccountsFromOrganizationBulkActionType = 'removeAccountsFromOrganization';
